// extracted by mini-css-extract-plugin
export default {"table":"MicropileDeepPlaneSummary_table__DzZqL","value":"MicropileDeepPlaneSummary_value__GQpnI","underline":"MicropileDeepPlaneSummary_underline__bdkaC"};